import './Faq.scss';
import React, { useState } from 'react';
import { Plus } from '../components/Icons';

const faqs = [
  {
    q: 'Do you offer free estimates?',
    a: 'Yes. Our mobile appraiser visits your property, walks the space with you and leaves a clear written quote with no obligation. Most quotes are booked within a few days of your call.',
  },
  {
    q: 'Are you licensed and insured?',
    a: 'We are fully licensed and carry $5 million in liability insurance on every job, so you never carry the risk. We are also BBB A+ accredited.',
  },
  {
    q: 'Is your work guaranteed?',
    a: 'Every painting project comes with a 3-year, 100% satisfaction guarantee. If the finish doesn’t hold up, we come back and make it right. No fine print.',
  },
  {
    q: 'How long does a typical project take?',
    a: 'A single room is usually done in a day or two, a full interior in about a week, and most exteriors within one to two weeks depending on size and weather. We confirm the schedule in your quote and stick to it.',
  },
  {
    q: 'Do I need to buy the paint myself?',
    a: 'No. We supply premium products from trusted brands and include patient, honest colour advice until you’re sure. If you already have a colour in mind, we match it.',
  },
  {
    q: 'Do you paint strata, commercial and warehouse buildings?',
    a: 'Yes. We scale our crew and schedule to buildings of every size, from a single unit to a full complex, office, retail space or warehouse interior.',
  },
];

const d = (ms: number) => ({ '--delay': `${ms}ms` }) as React.CSSProperties;

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="section faq">
      <div className="container">
        <div className="head head--center">
          <span className="eyebrow reveal">Got questions?</span>
          <h2 className="reveal" style={d(80)}>
            Frequently Asked Questions.
          </h2>
        </div>

        <div className="faq__list">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              // The reveal animation lives on a wrapper React never re-renders: it adds .is-visible to the DOM
              // directly, and a changing className here would wipe it and hide the question when clicked.
              <div key={f.q} className="reveal" style={d(i * 60)}>
                <div className={`faq__item${isOpen ? ' is-open' : ''}`}>
                  <button
                    className="faq__q"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-${i}`}
                  >
                    <span>{f.q}</span>
                    <span className="faq__icon">
                      <Plus />
                    </span>
                  </button>
                  <div id={`faq-${i}`} className="faq__a" role="region">
                    <div>
                      <p>{f.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
